import { trim, trimEnd } from 'lodash';

let assetVersion = '';

export default {
    set assetVersion(url) {
        // Trailing slashes are stripped so assetUrl() can safely join with a leading slash on the filename.
        assetVersion = trimEnd(url, '/');
    },

    get assetVersion() {
        return assetVersion;
    },

    assetUrl: function(filename) {
        var stripped = trim(filename, '/');
        return [assetVersion, stripped].join('/');
    }
};
